import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface ServerStatsProps {
  totalServers: number;
  comingSoon: number;
  newServers: number;
}
const ServerStats: React.FC<ServerStatsProps> = ({
  totalServers,
  comingSoon,
  newServers
}) => {
  const { t } = useLanguage();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="bg-gradient-to-br from-white via-blue-50 to-sky-50 dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 rounded-2xl p-6 text-center border-2 border-blue-200 dark:border-gray-700 shadow-lg dark:shadow-xl hover:shadow-xl dark:hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:border-sky-300">
        <div className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent mb-3">
          {totalServers}
        </div>
        <div className="text-gray-700 dark:text-gray-300 font-medium">{t('home.total_servers')}</div>
      </div>

      <div className="bg-gradient-to-br from-white via-sky-50 to-cyan-50 dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 rounded-2xl p-6 text-center border-2 border-sky-200 dark:border-gray-700 shadow-lg dark:shadow-xl hover:shadow-xl dark:hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:border-cyan-300">
        <div className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent mb-3">
          {newServers}
        </div>
        <div className="text-gray-700 dark:text-gray-300 font-medium">{t('home.new_this_week')}</div>
      </div>

      <div className="bg-gradient-to-br from-white via-cyan-50 to-teal-50 dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 rounded-2xl p-6 text-center border-2 border-cyan-200 dark:border-gray-700 shadow-lg dark:shadow-xl hover:shadow-xl dark:hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:border-teal-300">
        <div className="text-4xl font-bold bg-gradient-to-r from-green-400 to-green-600 bg-clip-text text-transparent mb-3">
          {comingSoon}
        </div>
        <div className="text-gray-700 dark:text-gray-300 font-medium">{t('home.coming_soon')}</div>
      </div>
    </div>
  );
};

export default ServerStats;